import { Route, Routes } from "react-router-dom";
import { OuvidoriaHome } from "pages/Ouvidoria/Home";

export const OuvidoriaRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<OuvidoriaHome />} />
    </Routes>
  );
};
